var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "leftpanel",
      class: { left0: _vm.showMenu, left220: !_vm.showMenu }
    },
    [
      _c("div", { staticClass: "leftpanelinner" }, [
        _c("div", { staticClass: "media leftpanel-profile" }, [
          _c(
            "div",
            { staticClass: "media-body" },
            [
              _c("span", { staticClass: "text-red fb account" }, [
                _vm._v(_vm._s(_vm.userInfo.userName) + " ")
              ]),
              _c("span", { staticClass: "text-warn" }, [
                _vm._v(
                  "Ví: " +
                    _vm._s(
                      _vm._f("formatNumber")(
                        _vm.customerInfo.Wallet || 0,
                        "0,0"
                      )
                    )
                )
              ]),
              _vm.customerLevelsDetail
                ? _c("rate", {
                    attrs: { level: _vm.customerLevelsDetail.VipValue }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "tab-content" }, [
          _c("div", { staticClass: "tab-pane active" }, [
            _c("ul", { staticClass: "nav nav-pills nav-stacked nav-quirk" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: { name: "profile" } } }, [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-user" }),
                      _vm._v("Tài khoản")
                    ])
                  ])
                ],
                1
              ),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: { name: "cart-index" } } }, [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-cart-arrow-down" }),
                      _vm._v("Giỏ hàng")
                    ])
                  ])
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "order-index" } } },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-bar-chart" }),
                        _vm._v("Đơn hàng")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "deposit-index" } } },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-envelope" }),
                        _vm._v("Ký gửi")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "payment-request-index" } } },
                    [
                      _c("span", [
                        _c("i", {
                          staticClass: "fa fa-money",
                          class: { noti: _vm.numberOfOrder > 0 },
                          attrs: { "data-total": _vm.numberOfOrder }
                        }),
                        _vm._v("Thanh toán")
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm.customerInfo.Hotline
        ? _c("div", { staticClass: "media leftpanel-profile hotline" }, [
            _c("p", [_vm._v("CSKH của bạn")]),
            _c("p"),
            _c(
              "p",
              { staticStyle: { color: "yellow", "font-weight": "700" } },
              [_vm._v(_vm._s(_vm.customerInfo.Hotline))]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }